let timerId: number | null = null;

export const useSessionTime = () => {
  const isOver50sec = useState<boolean>('sessionTimeOver50sec', () => false); // sessionTimeOver50sec - ручной флаг, вызов в 2 местах, чтобы оба ссылались на 1 объект

  const startTimer = () => {
    if (import.meta.server || isOver50sec.value || timerId !== null) {
      return;
    }

    timerId = window.setTimeout(() => {
      isOver50sec.value = true;
      timerId = null;
    }, 50000);
  };

  return {
    isOver50sec,
    startTimer
  };
};
